export default __webpack_public_path__ + "static/media/nuo.a777d733.svg";